import {useSessionStore} from '@/stores/session-store'

export function isLogined() {
  const {authInfo} = useSessionStore()
  return !!authInfo.value?.token
}
